export default __webpack_public_path__ + "static/media/pic6.362e58f4.png";